import { render } from "./I18n.vue?vue&type=template&id=05b13261&scoped=true"
import script from "./I18n.vue?vue&type=script&lang=js"
export * from "./I18n.vue?vue&type=script&lang=js"

import "./I18n.vue?vue&type=style&index=0&id=05b13261&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05b13261"

export default script